import React, { useEffect, useState } from "react";
import { getAssetCoin } from "../../utils";
import { useAuth } from "../../context/authContext";

const CoinLogo = ({ asset, size = 32, className = "" }) => {
  const { user } = useAuth();
  const [logoUrl, setLogoUrl] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Define which are fiat/base currencies
  const fiatCurrencies = [
    "USD",
    "EUR",
    "GBP",
    "IDR",
    "WON",
    "JPY",
    "KRW",
    "CNY",
    "MYR",
    "THB",
    "VND",
    "AUD",
    "CAD",
    "CHF",
    "SGD",
  ];

  useEffect(() => {
    const fetchLogo = async () => {
      if (!asset) {
        setIsLoading(false);
        return;
      }

      const symbol = asset.toUpperCase();

      // If it's a fiat currency, skip image fetch
      if (fiatCurrencies.includes(symbol)) {
        setLogoUrl(null);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setImageError(false); // Reset error state when asset changes
      const logo = await getAssetCoin(symbol);
      setLogoUrl(logo);
      setIsLoading(false);
    };

    if (user) {
      fetchLogo();
    }
  }, [asset, user]);

  const symbol = asset?.toUpperCase();
  const isFiat = fiatCurrencies.includes(symbol);

  if (isFiat) {
    return (
      <div
        className={`flex items-center justify-center rounded-full bg-gray-200 text-gray-800 font-semibold ${className}`}
        style={{
          width: size,
          height: size,
          fontSize: 8,
        }}
      >
        {symbol}
      </div>
    );
  }

  // Show loading state
  if (isLoading) {
    return (
      <div
        className={`rounded-full bg-gray-200 animate-pulse ${className}`}
        style={{
          width: size,
          height: size,
        }}
      />
    );
  }

  // build the chain of fallbacks:
  // 1) logoUrl from API
  // 2) local image /images/coin_icon/SYMBOL.png
  // 3) default image /images/coin_icon/default.png
  const src = imageError
    ? "/images/coin_icon/default.png"
    : logoUrl || `/images/coin_icon/${symbol}.png`;

  return (
    <img
      src={src}
      alt={symbol}
      width={size}
      height={size}
      className={`object-contain ${className}`}
      onError={() => setImageError(true)} // mark error to switch to default
    />
  );
};

export default CoinLogo;
